<template>
    <div class="transportOverviewM">
        <div class="panel">
            <div class="panelTitle">运输车概况</div>
            <div class="panelList">
                <div class="panelRow" @click="openTripModal">
                    <span class="label">在途料车</span>
                    <span class="value" v-if="onTheWay !== '' && onTheWay !== null">
                        <em>{{ onTheWay }}辆</em>
                    </span>
                    <span class="value empty" v-else>-/-</span>
                </div>
                <div class="panelRow" @click="openTripModal">
                    <span class="label">运输车数量</span>
                    <span class="value" v-if="transportNum !== '' && transportNum !== null">
                        <em>{{ transportNum }}辆</em>
                    </span>
                    <span class="value empty" v-else>-/-</span>
                </div>
                <div class="panelRow" @click="openTripModal">
                    <span class="label">当日运输车次</span>
                    <span class="value" v-if="transportTotal !== '' && transportTotal !== null">
                        <em>{{ transportTotal }}车次</em>
                    </span>
                    <span class="value empty" v-else>-/-</span>
                </div>
                 <div class="panelRow" @click="openTripModal">
                    <span class="label">已完成车次</span>
                    <span class="value" v-if="transportCompleted !== '' && transportCompleted !== null">
                        <em>{{ transportCompleted }}车次</em>
                    </span>
                    <span class="value empty" v-else>-/-</span>
                </div>
                <div class="panelRow" @click="openTripModal">
                    <span class="label">平均运输时间</span>
                    <span class="value" v-if="transportAverage !== '' && transportAverage !== null">
                        <em>{{ transportAverage }}min</em>
                    </span>
                    <span class="value empty" v-else>-/-</span>
                </div>
                <div class="panelRow" @click="openTripModal">
                    <span class="label">运输超时</span>
                    <span class="value warn" v-if="timeAbnormal">
                        {{ timeAbnormal }}车次({{ percentage }}%)
                    </span>
                    <span class="value empty" v-else>0</span>
                </div>
            </div>
        </div>
        <trip-info ref="tripInfo" :type="type" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import TripInfo from "./components/tripInfo.vue";
import {
    getQuantityOfTrucks,
    getTransportTodaySummary,
} from "@/api/api";

export default {
    components: {
        TripInfo,
    },
    props: {
        type: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            intervalId: null,
            onTheWay: "",
            transportNum: "",
            transportTotal: "",
            transportAverage: "",
            timeAbnormal: "",
            transportCompleted:"",
            percentage: "",
        };
    },
    created() {
        this.dataRefreh();
    },
    mounted() {
        this.getOnTheWay();
        this.getTotalCar();
    },
    beforeDestroy() {
        this.clear();
    },
    methods: {
        dataRefreh() {
            if (this.intervalId != null) return;
            this.intervalId = setInterval(() => {
                this.getOnTheWay();
                this.getTotalCar();
            }, 30000);
        },
        clear() {
            clearInterval(this.intervalId);
            this.intervalId = null;
        },
        async getOnTheWay() {
            if (!this.sectionId) return;
            let req = {
                mType: this.type,
                workAreaId: this.sectionId,
            };
            const otwData = await getQuantityOfTrucks(req);
            this.onTheWay = otwData.data.ways.length;
        },
        async getTotalCar() {
            if (!this.mixplantId) return;
            let req = {
                materialType: this.type || "lq",
                mixplantId: this.mixplantId,
                sectionId: this.seIds,
            };
            try {
                const res = await getTransportTodaySummary(req);
                if (res && res.data) {
                    const d = res.data;
                    this.onTheWay = d.inTransit.carCount|| 0;
                    this.transportNum = d.todayCarCount || 0;
                    this.transportTotal = d.todayTransportCount || 0;
                    this.transportAverage = d.avgTransportDurationMinutes || 0;
                    this.timeAbnormal = d.overTimeCount || 0;
                    this.transportCompleted = d.completed.carCount || 0;
                    this.percentage = d.upLimitRatio || 0;
                }
            } catch (e) {
                console.error("获取统计数据失败", e);
            }
        },
        openTripModal() {
            this.$refs.tripInfo && this.$refs.tripInfo.open();
        },
    },
    computed: mapState([
        "sectionId",
        "mixplantId",
        "seIds",
    ]),
    watch: {
        sectionId(curVal, oldVal) {
            if (!curVal || curVal === oldVal) return;
            this.getOnTheWay();
        },
        mixplantId(curVal, oldVal) {
            if (!curVal || curVal === oldVal) return;
            this.getTotalCar();
        },
    },
};
</script>

<style lang="less" scoped>
.transportOverviewM {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 0px;
    .panel {
        position: relative;
        width: 220px;
        height: 320px;
        padding: 8px 20px 16px;
        box-sizing: border-box;
        background: url(../assets/img/yscgk.png) no-repeat center / 100% 100%;
    }

    .panelTitle {
        position: relative;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        line-height: 1.4;
        padding-bottom: 20px;
        margin-bottom: 14px;

        // &::after {
        //     content: "";
        //     position: absolute;
        //     left: 50%;
        //     bottom: 0;
        //     width: 100%;
        //     height: 1px;
        //     transform: translateX(-50%);
        //     background: linear-gradient(
        //         90deg,
        //         transparent 0%,
        //         #18ffff 35%,
        //         #18ffff 65%,
        //         transparent 100%
        //     );
        // }
    }

    .panelList {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 80px);
    }

    .panelRow {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        line-height: 1.6;
        color: #fff;
        cursor: pointer;
        font-weight: 700;
        .label {
            flex-shrink: 0;
            margin-right: 12px;
        }

        .value {
            text-align: right;
            white-space: nowrap;

            em {
                font-style: normal;
                font-weight: 700;
                color: #fff721;
                margin-right: 2px;
            }

            &.warn {
                font-weight: 700;
                color: #ff5b6a;
            }

            &.empty {
                color: #fff721;
                font-weight: 700;
            }
        }

        &:hover {
            .label {
                text-shadow: 0 0 8px rgba(24, 255, 255, 0.45);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/transportOverview.vue